import React from 'react';
import RoleAnalyticsDashboard from './RoleAnalyticsDashboard';

const SuperUserDashboard = () => {
  return <RoleAnalyticsDashboard roleLabel="Super User Dashboard" />;
};

export default SuperUserDashboard;